import IconTradeTypes from './icon-trade-types';
import './icon-trade-types.scss';

export default IconTradeTypes;
